import {
	AdminMemberInfoType,
	BoardSearchType,
	BoardType,
	BoardWriteType,
	DashboardSearchType,
	DefaultSearchType,
	DeviceInfoModel,
	MemberInfoType,
	SpRequestType,
	UserSearchType,
} from 'constants/types'
import instance from './instance'
import fileDownload from 'js-file-download'
import exp from 'constants'
import {
	AskSearchType,
	HealthDataDetailRequestType,
	HealthDataSearchType,
	SellerAuthRequestType,
	SeniorVerifyType,
	ShopSellerDocumentRequestType,
	StatusType,
	SurveyMasterSearchType,
} from 'constants/appType'

/**
 * =====================================================
 * 환경설정
 * 1. 메뉴
 * 2. 공통코드
 * 3. 게시판
 * 4. 첨부파일
 * 5. 회원
 * 6. 프로젝트
 * =====================================================
 */

// ---------------------- 메뉴 목록 시작 ------------------
/**
 * 메뉴 목록 호출
 * @returns
 */
export const apiGetMenuList = async () => {
	return await instance.get('/admin/menu/list').then((result) => result.data)
}
// ---------------------- 메뉴 목록 끝 -------------------

// ---------------------- 공통코드 시작 ------------------

/**
 * 공통코드 1단계 목록
 * @returns
 */
export const apiCmmnCodeList1depth = async () => {
	return await instance.get('/cmmn/parentList').then((result) => result.data)
}

/**
 * parentId로 공통코드 목록 호출
 * @param parentId
 * @returns
 */
export const apiCmmnCodeByParentId = async (parentId: number) => {
	return await instance
		.get(`/cmmn/list/${parentId}`)
		.then((result) => result.data)
}

/**
 * 공통코드 저장
 * @param data
 * @returns
 */
export const apiCmmnCodeSave = async (data: any) => {
	return await instance.post('/cmmn/save', data).then((result) => result.data)
}

/**
 * 공통코드 삭제
 * @param id
 * @returns
 */
export const apiCmmnCodeDelete = async (id: number) => {
	return await instance
		.delete(`/cmmn/delete/${id}`)
		.then((result) => result.data)
}

// ---------------------- 공통코드 끝 ------------------

// ---------------------- 대시보드 시작 -----------------

/**
 * 대시보드 데이터
 */
export const apiDashboardStats = async (request: DashboardSearchType) => {
	return await instance
		.get('/admin/dashboard/stats', {
			params: request,
		})
		.then((res) => res.data)
}

// ---------------------- 대시보드 끝 ------------------

// ---------------------- 게시판 시작 ------------------

/**
 * 게시판 목록
 * @param reqeust
 * @returns
 */
export const apiBoardList = async (reqeust: BoardSearchType) => {
	return await instance
		.get('/board/list', {
			params: reqeust,
		})
		.then((result) => result.data)
}

/**
 * 게시물 열람
 * @param boardId
 * @returns
 */
export const apiBoardView = async (boardId: number) => {
	return await instance
		.get(`/board/detail/${boardId}`)
		.then((result) => result.data)
}

/**
 * 게시물 삭제
 * @param boardId
 * @returns
 */
export const apiBoardDelete = async (boardId: number) => {
	return await instance
		.delete(`/board/delete/${boardId}`)
		.then((result) => result.data)
}

/**
 * 게시물 다중 삭제
 * @param boardIds
 * @returns
 */
export const apiBoardDeleteMultiple = async (boardIds: number[]) => {
	return await instance
		.post(`/board/delete/multiple`, { ids: boardIds })
		.then((result) => result.data)
}

/**
 * 게시물 저장
 * @param data
 * @returns
 */
export const apiBoardSave = async (data: BoardType) => {
	return await instance.post('/board/save', data).then((result) => result.data)
}

/** 게시판 팝업 목록
 * @returns
 */
export const apiPopupList = async () => {
	return await instance.get('/board/popupList').then((result) => result.data)
}

// ---------------------- 게시판 끝 ------------------

// ---------------------- 파일 API 시작 ------------------

/**
 * 첨부파일 마스터 ID
 */
export const fileMasterId = async () => {
	return await instance.get('/file/get/id').then((res) => res.data)
}

/**
 * attachFileId 로 파일 목록 찾기 (마스터 테이블 조회)
 * @param attachFileId
 */
export const attachFileList = async (attachFileId: string) => {
	return await instance
		.get(`/file/list`, {
			params: {
				attachFileId,
			},
		})
		.then((res) => res.data)
}

/**
 * 파일 업로드
 * @param {*} files
 */
export const apiFileUpload = async (
	files: File,
	filePosition: string,
	orderNo: number,
) => {
	// 저장된 파일명을 담을 배열
	const returnArr = []

	const formData = new FormData()
	formData.append('file', files)
	formData.append('filePosition', filePosition)
	formData.append('orderNo', orderNo.toString())

	const { data } = await instance.post(`/common/file/save`, formData)

	returnArr.push(data)

	return returnArr
}

/**
 * 에디터 이미지 업로드
 * @param file
 * @returns
 */
export const apiEditorImageUpload = async (file: File) => {
	console.log(file)
	const formData = new FormData()
	formData.append('file', file)

	const { data } = await instance.post(`/common/file/editorImageSave`, formData)

	return data
}

/**
 * 동영상 업로드
 * @param files
 * @param attachFileId
 * @param fileDest
 * @returns
 */
export const videoUpload = async (
	files: File[],
	attachFileId: string,
	fileDest: string,
) => {
	// 저장된 파일명을 담을 배열
	const returnArr = []

	for (let i = 0; i < files.length; i++) {
		const formData = new FormData()
		formData.append('file', files[i])
		formData.append('fileDest', fileDest)
		formData.append('attachFileId', attachFileId)

		const { data } = await instance.post(`/video/save`, formData)
		returnArr.push(data)
	}

	return returnArr
}

/**
 * 첨부파일 삭제
 * @param fileDeleteRequest
 * {
 *   saveFileName
 * }
 */
export const apiFileDelete = async (storedFileName: string) => {
	return await instance
		.delete(`/common/file/delete/${storedFileName}`)
		.then((res) => res.data)
}

/**
 * 첨부파일 다운로드 by fileId
 * @param fileId
 * @param orgFileName
 * @returns
 */
export const apiFileDownloadByFileId = async (
	fileId: number,
	orgFileName: string,
) => {
	return await instance
		.get(`/file/view/id/${fileId}`, {
			responseType: 'blob',
		})
		.then((res) => {
			fileDownload(res.data, orgFileName)
		})
}

/**
 * 첨부파일 다운로드 by fileName (rename되어 DB에 저장된 파일명)
 * @param storedFileName
 * @param originalFileName
 * @returns
 */
export const apiFileDownloadByFileName = async (
	storedFileName: string,
	originalFileName: string,
) => {
	return await instance
		.get(`/common/file/download/${storedFileName}`, {
			responseType: 'blob',
		})
		.then((res) => {
			fileDownload(res.data, originalFileName)
		})
}

/**
 * 첨부파일 목록 by attachFileId, fileDest
 * @param attachFileId
 * @param fileDest
 * @returns
 */
export const apiFileListByAttachFileIdAndFileDest = async (
	attachFileId: string,
	fileDest: string,
) => {
	return await instance
		.get(`/file/listByDest`, {
			params: {
				attachFileId,
				fileDest,
			},
		})
		.then((res) => res.data)
}

// ---------------------- 파일 API 끝 ------------------

// ---------------------- 회원 API 시작 ------------------

/**
 * 회원 목록
 * @param request
 * @returns
 */
export const apiUserList = async (request: UserSearchType) => {
	return await instance
		.get(`/admin/user/list`, {
			params: request,
		})
		.then((res) => res.data)
}

/**
 * 관리자에 의한 회원 정보 수정
 * @param userList
 * @returns
 */
export const apiUserInfoUpdateByAdmin = async (
	userList: AdminMemberInfoType[],
) => {
	console.log({ userList: userList })
	return await instance
		.put(`/admin/user/save`, {
			userList,
		})
		.then((res) => res.data)
}

/**
 * id로 회원 권한 목록 조회
 * @param id
 * @returns
 */
export const apiMemberRoleList = async (id: number) => {
	return await instance
		.get(`/member/roleList`, {
			params: {
				id,
			},
		})
		.then((res) => res.data)
}

/**
 * 계정 저장 (insert, update)
 * @param request
 * @returns
 */
export const apiMemberSave = async (request: MemberInfoType) => {
	return await instance.post(`/auth/register`, request).then((res) => res.data)
}

/**
 * username 중복체크
 * @param username
 * @returns
 */
export const apiMemberUsernameExist = async (username: string) => {
	return await instance
		.get(`/auth/check/username`, {
			params: {
				username,
			},
		})
		.then((res) => res.data)
}

/**
 * email 중복체크
 * @param email
 * @returns
 */
export const apiMemberEmailExist = async (email: string) => {
	return await instance
		.get(`/auth/check/email`, {
			params: {
				email,
			},
		})
		.then((res) => res.data)
}

/**
 * 로그아웃 처리
 * @param request
 * @returns
 */
export const apiLogout = async (request: DeviceInfoModel) => {
	console.log(request)
	return await instance
		.post(`/user/logout`, {
			deviceInfo: request,
		})
		.then((res) => res.data)
}

/**
 * 이메일 인증 처리
 * @param token
 * @returns
 */
export const apiRegistrationConfirmation = async (token: string) => {
	return await instance
		.get(`/auth/registrationConfirmation?token=${token}`)
		.then((res) => res.data)
}

/**
 * 이메일 재전송
 * @param token
 * @returns
 */
export const apiResendRegistrationToken = async (token: string) => {
	return await instance
		.get(`/auth/resendRegistrationToken?token=${token}`)
		.then((res) => res.data)
}

/**
 * 판매자 정보 조회 by sellerId, userId
 * @param sellerId
 * @param userId
 * @returns
 */
export const apiShopSellerInfoBySellerIdAndUserId = async (
	sellerId: number,
	userId: number,
) => {
	return await instance
		.get(`/shop/seller/info`, {
			params: {
				sellerId,
				userId,
			},
		})
		.then((res) => res.data)
}

/**
 * 판매자 문서 조회 by sellerId, documentType
 * @param request
 * @returns
 */
export const apiShopSellerDocuments = async (
	request: ShopSellerDocumentRequestType,
) => {
	return await instance
		.get(`/shop/seller/documents`, {
			params: request,
			responseType: request.download ? 'blob' : 'json',
		})
		.then((res) => {
			if (!request.download) {
				return res.data
			}

			const contentDisposition = res.headers['content-disposition'] || ''
			const fileNameMatch = contentDisposition.match(
				/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i,
			)
			const encodedFileName = fileNameMatch?.[1] || fileNameMatch?.[2]
			const fileName = encodedFileName
				? decodeURIComponent(encodedFileName)
				: `${request.documentType}_${request.documentId}`

			fileDownload(res.data, fileName)

			return res.data
		})
}

/**
 * 판매자 승인 처리
 */
export const apiShopSellerAuth = async (request: SellerAuthRequestType) => {
	return await instance.put(`/shop/seller/auth`, request).then((res) => res.data)
}

// ---------------------- 회원 API 끝 ------------------

/**
 * =====================================================
 * 아래부터 고객사 요청 API
 * =====================================================
 */

export const apiProductSave = async (request: SpRequestType) => {
	return await instance
		.post(`/admin/product/save`, request)
		.then((res) => res.data)
}

export const apiProductList = async (request: any) => {
	return await instance
		.get(`/admin/product/list`, {
			params: request,
		})
		.then((res) => res.data)
}

/**
 * 설문조사 마스터 목록 조회
 * @param request
 * @returns
 */
export const apiSurveyMasterList = async (request: SurveyMasterSearchType) => {
	return await instance
		.get(`/survey/master/list`, {
			params: request,
		})
		.then((res) => res.data)
}

/**
 * 설문조사 마스터 저장
 * @param request
 */
export const apiSurveyMasterSave = async (request: SpRequestType) => {
	return await instance
		.post(`/survey/master/save`, request)
		.then((res) => res.data)
}

/**
 * 설문조사 마스터 상세 조회
 * @param id
 * @returns
 */
export const apiSurveyMasterById = async (id: number) => {
	return await instance.get(`/survey/${id}`).then((res) => res.data)
}

/**
 * 설문조사 문항 저장
 * @param request
 */
export const apiSurveyDetailsSave = async (request: SpRequestType) => {
	return await instance
		.post(`/survey/details/save`, request)
		.then((res) => res.data)
}

/**
 * 설문조사 문항별 답변 조회
 * @param surveyId
 * @returns
 */
export const apiSurveyAnswersBySurveyId = async (surveyId: number) => {
	return await instance
		.get(`/survey/answers/${surveyId}`)
		.then((res) => res.data)
}

/**
 * 1:1 문의 목록 조회
 * @param request
 * @returns
 */
export const apiAskList = async (request: AskSearchType) => {
	return await instance
		.get(`/common/ask/list`, {
			params: request,
		})
		.then((res) => res.data)
}

/**
 * 1:1 문의 저장
 * @param request
 * @returns
 */
export const apiAskSave = async (request: SpRequestType) => {
	return await instance.post(`/common/ask/save`, request).then((res) => res.data)
}

/**
 * 1:1 문의 상세 조회
 * @param id
 * @returns
 */
export const apiAskDetail = async (id: number) => {
	return await instance.get(`/common/ask/detail/${id}`).then((res) => res.data)
}

/**
 * 보호자가 시니어 추가 요청
 * headers에 보호자 인증 토큰 필요
 * @returns username
 */
// export const apiAddSenior = async () => {
// 	return await instance.get(`/auth/add/senior`).then((res) => res.data)
// }

/**
 * 보호자의 시니어 인증 처리
 * @param request
 * @returns
 */
export const apiVerifySenior = async (request: SeniorVerifyType) => {
	return await instance
		.post(`/auth/verify/senior`, request)
		.then((res) => res.data)
}

/**
 * 보호자가 시니어 삭제 요청
 * @param username
 * @returns
 */
export const apiRemoveSenior = async (username: string) => {
	return await instance
		.delete(`/auth/remove/senior/${username}`)
		.then((res) => res.data)
}

/**
 * 웨어러블 데이터 저장
 * @param request
 * @returns
 */
export const apiHealthDataSave = async (request: SpRequestType) => {
	return await instance
		.post(`/common/health-data/save`, request)
		.then((res) => res.data)
}

/**
 * 웨어러블 데이터 목록 조회
 * @param request
 * @returns
 */
export const apiHealthDataList = async (request: HealthDataSearchType) => {
	return await instance
		.get(`/common/health-data/list`, {
			params: request,
		})
		.then((res) => res.data)
}

/**
 * 웨어러블 데이터 요약 목록 조회
 * @param request
 * @returns
 */
export const apiHealthDataSummaryList = async (
	request: HealthDataSearchType,
) => {
	return await instance
		.get(`/common/health-data/summary`, {
			params: request,
		})
		.then((res) => res.data)
}

/** * 웨어러블 데이터 상세 조회
 * @param id
 * @returns
 */
export const apiHealthDataDetail = async (
	request: HealthDataDetailRequestType,
) => {
	return await instance
		.get(`/common/health-data/detail`, {
			params: request,
		})
		.then((res) => res.data)
}

/** * 웨어러블 데이터 요약 상세 조회
 * @param id
 * @returns
 */
export const apiHealthDataSummaryDetail = async (
	request: HealthDataSearchType,
) => {
	return await instance
		.get(`/common/health-data/summary-daily`, {
			params: request,
		})
		.then((res) => res.data)
}

/**
 * 사용자 요약 정보 조회 by userId
 * @param userId
 * @returns
 */
export const apiUserSummaryByUserId = async (userId: number) => {
	return await instance.get(`/user/summary/${userId}`).then((res) => res.data)
}

export const apiUserAddressSave = async (request: SpRequestType) => {
	return await instance
		.post(`/common/user-address/save`, request)
		.then((res) => res.data)
}
